(()=> {
  const box = document.querySelector('.impact-box');
  if (!box) return;

  const variantId = parseInt(box.dataset.variantId,10);        // €1-variant
  const sellingPlanId = box.dataset.sellingPlanId ? parseInt(box.dataset.sellingPlanId,10) : null;

  const btnDonate = document.getElementById('donateBtn');
  const custom = document.getElementById('amtCustom');
  const presetBtns = [...document.querySelectorAll('.amt')];
  const toggleBtns = [...document.querySelectorAll('.tg')];

  const err = document.createElement('div');
  err.className = 'err';
  err.textContent = 'Er ging iets mis. Probeer het nog eens.';
  box.appendChild(err);

  let mode = 'one';   // 'one' of 'monthly'
  let amount = parseInt(presetBtns[0]?.dataset.val || '5',10);

  // toggle eenmalig/maandelijks
  toggleBtns.forEach(b=>{
    b.addEventListener('click',()=>{
      toggleBtns.forEach(x=>x.classList.remove('active'));
      b.classList.add('active');
      mode = b.dataset.mode;
    });
  });

  // preset bedragen
  presetBtns.forEach(b=>{
    b.addEventListener('click',()=>{
      presetBtns.forEach(x=>x.classList.remove('active'));
      b.classList.add('active');
      amount = parseInt(b.dataset.val,10);
      custom.value = '';
    });
  });

  // custom bedrag
  custom.addEventListener('input',()=>{
    const v = parseInt(custom.value,10);
    if(!isNaN(v) && v>0 && v<=5000){
      amount = v;
      presetBtns.forEach(x=>x.classList.remove('active'));
    }
  });

  async function addAndCheckout() {
    err.classList.remove('show');
    if (!variantId || amount < 1) return;

    btnDonate.disabled = true;

    const item = {
      id: variantId,
      quantity: amount,                            // €1 x amount = totaalbedrag
    };
    if (mode === 'monthly' && sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    const payload = {
      items: [item],
      attributes: { source: 'donation-hero', mode, euros: amount }
    };

    try {
      await fetch('/cart/clear.js', { method: 'POST' });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(payload)
      });
      // tracking (optioneel)
      if (window.dataLayer) {
        window.dataLayer.push({event:'donation_add', value: amount, mode});
      }
      window.location.href = '/checkout';
    } catch(e) {
      err.classList.add('show');
    } finally {
      btnDonate.disabled = false;
    }
  }

  btnDonate.addEventListener('click', addAndCheckout);
})();
